<template>
  <div v-if="touchpoint || isRetakeReadyToOpen">
    <ReplayLoginModal
      v-if="touchpoint && retake"
      :redirect="retakeLink()"
      @close="closeLogin"
      @signed-in="continueAfterSignIn"
    />
    <RetakeReadyPrompt
      v-if="isRetakeReadyToOpen"
      @open="openBlockedRetake"
      @close="isRetakeReadyToOpen = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import util from '../../util'
import storage from '../../services/storage'
import ReplayLoginModal from './ReplayLoginModal.vue'
import RetakeReadyPrompt from './RetakeReadyPrompt.vue'
import RetakeMixin from './retake.mixin'

const UNLOCKED_SESSION_KEY = 'retakeUnlockedSessionId'

export default {
  components: { ReplayLoginModal, RetakeReadyPrompt },
  mixins: [RetakeMixin],
  data: () => ({ isRetakeReadyToOpen: false }),
  computed: {
    ...mapState('replay', { touchpoint: 'retakeLoginTouchpoint' }),
    ...mapGetters('replay', ['hasPassedRetakePoint', 'isRetakeSessionOver', 'retakeSessionId']),
  },
  watch: {
    hasPassedRetakePoint: {
      immediate: true,
      handler(hasPassed) {
        if (!hasPassed) return
        this.$store.commit('replay/unlockRetake')
        this.rememberUnlock()
      },
    },
    retakeSessionId: {
      immediate: true,
      handler(sessionId) {
        if (!sessionId || !this.$store.getters['replay/isEnabled']) return
        if (this.hasPassedRetakePoint) this.rememberUnlock()
        const presentationId = this.$store.state.presentation?.id
        const unlockedSessionId = storage.getValueByPresentation(presentationId, UNLOCKED_SESSION_KEY)
        if (unlockedSessionId === sessionId) this.$store.commit('replay/unlockRetake')
      },
    },
  },
  methods: {
    rememberUnlock() {
      if (!this.retakeSessionId || !this.$store.getters['replay/isEnabled']) return
      const presentationId = this.$store.state.presentation?.id
      storage.setValueByPresentation(presentationId, UNLOCKED_SESSION_KEY, this.retakeSessionId)
    },
    hideLogin() {
      this.$store.commit('replay/closeRetakeLogin')
    },
    closeLogin() {
      util.ga4Track('click_replay_login_close', this.retakeTrackingPayload(this.touchpoint))
      this.hideLogin()
    },
    continueAfterSignIn() {
      util.ga4Track('complete_replay_login', this.retakeTrackingPayload(this.touchpoint))
      this.hideLogin()
      if (this.isRetakeSessionOver) {
        window.location.href = this.retakeLink()
        return
      }
      this.isRetakeReadyToOpen = !this.openRetakeTab()
    },
    // No noopener in the features: with it window.open returns null, which would hide a blocked popup.
    openRetakeTab() {
      const tab = window.open(this.retakeLink(), '_blank')
      if (!tab) return false
      tab.opener = null
      return true
    },
    openBlockedRetake() {
      this.openRetakeTab()
      this.isRetakeReadyToOpen = false
    },
  },
}
</script>
